import { render, staticRenderFns } from "./historicoDialog.vue?vue&type=template&id=d3e95b3a&"
import script from "./historicoDialog.vue?vue&type=script&lang=js&"
export * from "./historicoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports